import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import PATHS from "../../../constants/paths";
import HomeSettingView from "./home.view";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as SettingService from "../../../services/SettingService";

import {
  getAuthUserSelector,
  getRoleSelector,
} from "../../../store/selectors/authSelector";

const HomeSettingContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector(getAuthUserSelector);
  const role = useSelector(getRoleSelector);
  const [canSyncroData, setCanSyncroData] = useState(false);

  const loadData = useCallback(async () => {
    const result = await SettingService.listAllSettings();
    if (result) {
      setCanSyncroData(result || false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <HomeSettingView
        userInfo={userInfo}
        role={role}
        canSyncroData={canSyncroData}
      />
    </>
  );
};

HomeSettingContainer.propTypes = {};

export default HomeSettingContainer;
